export default __webpack_public_path__ + "static/pic1-56ceed3f8e38e10d5ed385e74a4a7182.jpg";